import { render, staticRenderFns } from "./cookie_snack.vue?vue&type=template&id=132a857d&scoped=true&"
import script from "./cookie_snack.vue?vue&type=script&lang=js&"
export * from "./cookie_snack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132a857d",
  null
  
)

export default component.exports